import $api from "http";
import { notifyRequestChange } from './RequestCountEvents';
import { normalizeVehiclePayload } from './VehicleNumberService';

export const getRequestHistory = (params) =>
  $api.get("/tabel/request-history/", { params });
export const getRequestStatistics = (params) =>
  $api.get("/tabel/request-statistics/", { params });
export const correctRegistration = (id, data) =>
  $api.patch(`/tabel/driver-checked/${id}/`, normalizeVehiclePayload(data)).then(notifyRequestChange);
export const correctBaseRequest = (id, data) =>
  $api.patch(`/tabel/base-requests/${id}/`, normalizeVehiclePayload(data)).then(notifyRequestChange);
